// extracted by mini-css-extract-plugin
export default {"videoInfo":"style_videoInfo__38dVk","videoStats":"style_videoStats__cdoo-","videoWrapper":"style_videoWrapper__5m0sz","title":"style_title__4JTFr"};